import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ActiveStudentService } from '../services/startup/active-student/active-student.service';
import { StudentCourseStoreService } from '../services/stores/students/course/student-course-store.service';
import { tryParseInt } from '../utilities/convert';

@Injectable({
	providedIn: 'root',
})
export class StudentRegistrationActiveGuard {
	constructor(
		private studentCourseStore: StudentCourseStoreService,
		private activeStudent: ActiveStudentService,
		private router: Router,
	) {}

	canActivate(route: ActivatedRouteSnapshot) {
		return this.checkForCourse$(route);
	}

	canActivateChild(childRoute: ActivatedRouteSnapshot) {
		return this.checkForCourse$(childRoute);
	}

	public checkForCourse$ = (route: ActivatedRouteSnapshot) => {
		return this.activeStudent.getActiveStudent$().pipe(
			switchMap((sId) =>
				combineLatest([
					this.studentCourseStore.current$(sId),
					this.studentCourseStore.currentPersistent$(sId),
				]),
			),
			take(1),
			map(([currentCourses, persistentCourses]) => {
				const regId = tryParseInt(route.params.registrationId);
				return currentCourses
					.concat(persistentCourses)
					.find((c) => c.registration_id === regId)
					? true
					: this.router.createUrlTree(['/']);
			}),
		);
	};
}
